export default class Deck {
  cards = [];
  constructor(name="Untitled",description ="no description given", quizid=0){
    this.deckname = name;
    this.deckdescription = description;
    this.quizid = quizid;
  }

}
